import { useConfirm } from 'primevue/useconfirm'

export interface ConfirmActionOptions {
  message: string
  header: string
  icon?: string
  acceptLabel?: string
  rejectLabel?: string
  onAccept: () => void
  onReject?: () => void
}

export function useConfirmAction() {
  const confirm = useConfirm()

  const confirmAction = ({
    message,
    header,
    icon = 'pi pi-exclamation-triangle',
    acceptLabel,
    rejectLabel,
    onAccept,
    onReject
  }: ConfirmActionOptions): void => {
    confirm.require({
      message,
      header,
      icon,
      acceptLabel,
      rejectLabel,
      accept: onAccept,
      reject: onReject
    })
  }

  return {
    confirmAction
  }
}
